/**
 * BillingWalletApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Reason } from './reason';
import { TransactionType } from './transactionType';

export interface ClientWalletTransactionDto { 
    transactionId?: string;
    walletId?: string;
    transactionType?: TransactionType;
    clientResourceId?: string;
    reason?: Reason;
    transactionNote?: string;
    amount?: number;
    previousBalance?: number;
    currentBalance?: number;
    dateCreated?: Date;
    transactionTime?: Date;
}